import { PublicClientApplication } from "@azure/msal-browser";
import { JwtTokenFn } from "@me8eon/authentication";

export function msalJwtToken(msal: PublicClientApplication): JwtTokenFn {
    return async () => {
        const accounts = msal.getAllAccounts();
        const account = accounts[0];
        return account?.idToken || "";
    };
}